var test = require('tap').test
var minimatch = require('../')

test('extglob ending with statechar', function(t) {
  t.notOk(minimatch('ax', 'a?(b*)'))
  t.ok(minimatch('ax', '?(a*|b)'))
  t.end()
})



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/~/glob/~/minimatch/test/extglob-ending-with-state-char.js
 ** module id = 82
 ** module chunks = 1
 **/